var _tspan, _tspan2, _tspan3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberHelpZee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "118.69 141.38 188.59 141.38 188.59 139.1 120.97 139.1 120.97 76.04 51.13 76.04 51.13 78.26 118.69 78.26 118.69 141.38",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.44px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.63,
    y1: 56.84,
    x2: 193.09,
    y2: 56.84,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.59,
    y1: 56.84,
    x2: 186.31,
    y2: 59.12,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.59,
    y1: 56.84,
    x2: 190.81,
    y2: 54.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.59,
    y1: 56.84,
    x2: 188.59,
    y2: 52.34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.59,
    y1: 56.84,
    x2: 188.59,
    y2: 134.6,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.13,
    y1: 56.84,
    x2: 48.85,
    y2: 59.12,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.13,
    y1: 56.84,
    x2: 53.35,
    y2: 54.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.13,
    y1: 56.84,
    x2: 51.13,
    y2: 52.34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.13,
    y1: 56.84,
    x2: 51.13,
    y2: 71.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(107.53 53.72)",
    style: {
      fill: "#000",
      fontFamily: "ArialMT, Arial",
      fontSize: "9.51px"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "Widt"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 19.24,
    y: 0
  }, "h"))), /*#__PURE__*/React.createElement("line", {
    x1: 211.87,
    y1: 71.48,
    x2: 211.87,
    y2: 145.88,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.87,
    y1: 141.38,
    x2: 209.65,
    y2: 139.1,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.87,
    y1: 141.38,
    x2: 214.15,
    y2: 143.6,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.87,
    y1: 141.38,
    x2: 216.43,
    y2: 141.38,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.87,
    y1: 141.38,
    x2: 193.09,
    y2: 141.38,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.87,
    y1: 76.04,
    x2: 209.65,
    y2: 73.76,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.87,
    y1: 76.04,
    x2: 214.15,
    y2: 78.26,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.87,
    y1: 76.04,
    x2: 216.43,
    y2: 76.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.87,
    y1: 76.04,
    x2: 125.47,
    y2: 76.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(208.93 121.22) rotate(-90)",
    style: {
      fill: "#000",
      fontFamily: "ArialMT, Arial",
      fontSize: "9.51px"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "Dept"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 19.81,
    y: 0
  }, "h"))), /*#__PURE__*/React.createElement("line", {
    x1: 114.19,
    y1: 125.18,
    x2: 125.47,
    y2: 125.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "119.83 126.18 119.23 123.36 117.49 121.02 114.85 119.4 111.79 118.86",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.97,
    y1: 125.18,
    x2: 118.69,
    y2: 127.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.97,
    y1: 125.18,
    x2: 123.25,
    y2: 122.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.97,
    y1: 125.18,
    x2: 120.97,
    y2: 120.68,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.97,
    y1: 125.18,
    x2: 120.97,
    y2: 126.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.69,
    y1: 125.18,
    x2: 116.47,
    y2: 127.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.69,
    y1: 125.18,
    x2: 120.97,
    y2: 122.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".84px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.69,
    y1: 125.18,
    x2: 118.69,
    y2: 120.68,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.69,
    y1: 125.18,
    x2: 118.69,
    y2: 126.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".48px"
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(69.19 121.1)",
    style: {
      fill: "#000",
      fontFamily: "ArialMT, Arial",
      fontSize: "9.51px"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.82,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "hi"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.08,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.82,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.63,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "ne"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.07,
    y: 0,
    style: {
      letterSpacing: "0em"
    }
  }, "s"), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 37.81,
    y: 0
  }, "s")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberHelpZee);
export default __webpack_public_path__ + "static/media/MemberHelpZee.d71c955c4db1b13b5413c79418ccd939.svg";
export { ForwardRef as ReactComponent };